/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Contact_Reactivate_ErrorInputs */

const en_case_contact_reactivate_error = /** @type {(inputs: Case_Contact_Reactivate_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to reactivate contact: ${i?.message}`)
};

const pt_br2_case_contact_reactivate_error = /** @type {(inputs: Case_Contact_Reactivate_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao reativar contato: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to reactivate contact: {message}" |
*
* @param {Case_Contact_Reactivate_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_reactivate_error = /** @type {((inputs: Case_Contact_Reactivate_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Reactivate_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_reactivate_error(inputs)
	return pt_br2_case_contact_reactivate_error(inputs)
});